var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer-service-inner"},[_c('div',{staticClass:"desc"},[_vm._v("微信客服：")]),_c('img',{staticClass:"qrcode",attrs:{"src":require("../assets/images/cm-qr.jpg")}}),_c('div',{staticClass:"desc"},[_vm._v("客服微信：dakaxiangji01")]),_c('div',{staticClass:"desc"},[_vm._v("官方QQ群：720844363")])])
}]

export { render, staticRenderFns }